"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitHandler = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const initialRequestState = {
    status: 'idle',
    result: null,
    prompt: null,
};
const useSubmitHandler = (onPromptSubmit, onStatusChange) => {
    const textAreaRef = (0, react_1.useRef)(null);
    const [prompt, setPrompt] = (0, react_1.useState)(null);
    const [status, setStatus] = (0, react_1.useState)(initialRequestState);
    const onSubmit = (0, react_1.useCallback)((inputPrompt, data) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (!inputPrompt) {
            return setStatus(initialRequestState);
        }
        setStatus((previousState) => (Object.assign(Object.assign({}, previousState), { result: null, status: 'loading', prompt: inputPrompt })));
        onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange('loading', '');
        try {
            const response = yield onPromptSubmit(inputPrompt, data);
            setStatus((previousState) => {
                /**
                 * If the status is idle, it means the user has cancelled the request
                 * If the prompt has changed, it means the user has submitted a new request
                 * and we should ignore the response.
                 */
                if (previousState.status === 'idle' ||
                    previousState.prompt !== inputPrompt) {
                    onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange('idle', '');
                    return previousState;
                }
                onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(response.result && !response.error ? 'success' : 'error', typeof (response === null || response === void 0 ? void 0 : response.result) === 'string' ? response.result : '');
                return Object.assign(Object.assign({}, previousState), { status: response.result && !response.error ? 'success' : 'error', result: typeof (response === null || response === void 0 ? void 0 : response.result) === 'string'
                        ? response.result
                        : (response === null || response === void 0 ? void 0 : response.error.message) || null });
            });
        }
        catch (error) {
            setStatus({
                status: 'error',
                result: null,
                prompt: null,
            });
        }
    }), [onPromptSubmit, onStatusChange]);
    const onClear = (0, react_1.useCallback)(() => {
        setPrompt(null);
        setStatus(initialRequestState);
        // clear textarea
        if (textAreaRef === null || textAreaRef === void 0 ? void 0 : textAreaRef.current) {
            textAreaRef.current.value = '';
            textAreaRef.current.focus();
        }
    }, [textAreaRef, setPrompt, setStatus]);
    const onCancel = (0, react_1.useCallback)(() => {
        setStatus(initialRequestState);
    }, []);
    return Object.assign(Object.assign({}, status), { textAreaRef,
        prompt,
        setPrompt,
        onSubmit,
        onClear,
        onCancel });
};
exports.useSubmitHandler = useSubmitHandler;
//# sourceMappingURL=useSubmitHandler.js.map